import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const barreiraRestauradora: TechniqueDefinition = {
  id: "barreira_restauradora",
  name: "Barreira Restauradora",
  description: "Heals an ally and then grants them a protective shield.",
  family: "medical_ninjutsu",
  proficiency: "ninjutsu",
  targeting: "ally_injured_or_threatened",
  behavior: { kind: "restorative_barrier" },
  shieldKey: "restorative_barrier",
  levels: {
    1: {
      chakraCost: 26,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 12,
      healCoefficient: 0.55,
      shieldBase: 18,
      shieldCoefficient: 0.75,
      shieldDurationMs: 2_000,
    },
    2: {
      chakraCost: 27,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 13,
      healCoefficient: 0.57,
      shieldBase: 19,
      shieldCoefficient: 0.78,
      shieldDurationMs: 2_300,
    },
    3: {
      chakraCost: 28,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 13,
      healCoefficient: 0.6,
      shieldBase: 21,
      shieldCoefficient: 0.81,
      shieldDurationMs: 2_700,
    },
    4: {
      chakraCost: 29,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 14,
      healCoefficient: 0.62,
      shieldBase: 22,
      shieldCoefficient: 0.85,
      shieldDurationMs: 3_000,
    },
    5: {
      chakraCost: 30,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 15,
      healCoefficient: 0.65,
      shieldBase: 24,
      shieldCoefficient: 0.88,
      shieldDurationMs: 3_300,
    },
    6: {
      chakraCost: 31,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 15,
      healCoefficient: 0.67,
      shieldBase: 25,
      shieldCoefficient: 0.92,
      shieldDurationMs: 3_700,
    },
    7: {
      chakraCost: 32,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 16,
      healCoefficient: 0.7,
      shieldBase: 26,
      shieldCoefficient: 0.95,
      shieldDurationMs: 4_000,
    },
    8: {
      chakraCost: 33,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 17,
      healCoefficient: 0.72,
      shieldBase: 27,
      shieldCoefficient: 0.98,
      shieldDurationMs: 4_300,
    },
    9: {
      chakraCost: 33,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 17,
      healCoefficient: 0.74,
      shieldBase: 28,
      shieldCoefficient: 1.02,
      shieldDurationMs: 4_700,
    },
    10: {
      chakraCost: 34,
      cooldownMs: 10_000,
      range: 180,
      maxTargets: 1,
      power: 0,
      attackCoefficient: 0,
      healBase: 18,
      healCoefficient: 0.75,
      shieldBase: 28,
      shieldCoefficient: 1.05,
      shieldDurationMs: 5_000,
    },
  },
  visual: {
    effectId: 161,
    castEffectId: null,
    shieldStatusEffectId: 161,
  },
};
